<script>
import { socketConnect } from "@/helpers/webSocketHandler";
import { authComputed } from "@/state/helpers";
import Swal from "sweetalert2";

export default {
  page: {
    title: "Agent Console",
  },
  computed: {
    ...authComputed,
  },
  data() {
    return {
      videoCallCommunication: null,
      kioskCommunication: null,
      videoSetting: { mode: "monitor", agent_mic: false },
      domain: "8x8.vc",
      video_mode_status: false,
      micStatus: true,
      checkin_step: {
        current_step: "home",
        reset_kiosk: false,
        wait: false,
        max_min: false,
      },
      jitsiApi: "",
      isOnWait: false,
      isMinMax: false,
    };
  },
  mounted() {
    this.connectVideoCallCommunication();
    this.loadScript(
      "https://8x8.vc/vpaas-magic-cookie-0e791abbadeb4077a4471cbd4f67d198/external_api.js",
      () => {
        if (!window.JitsiMeetExternalAPI)
          throw new Error("Jitsi Meet API not loaded");
        this.embedJitsiWidget();
      }
    );
  },
  beforeDestroy() {
    this.removeJitsiWidget();
    this.kioskCommunication.close();
  },
  methods: {
    // Method is used to connection kiosk
    connectVideoCallCommunication() {
      const kioskId = localStorage.getItem("kiosk_id");
      this.kioskCommunication = socketConnect(
        `kiosk/kiosk_communication/${kioskId}?token=${this.user.access}`
      );
      if (this.kioskCommunication !== null) {
        this.watchSocketEvent();
      }
    },
    loadScript(src, cb) {
      const scriptEl = document.createElement("script");
      scriptEl.src = src;
      scriptEl.async = 1;
      document.querySelector("head").appendChild(scriptEl);
      scriptEl.addEventListener("load", cb);
    },
    embedJitsiWidget() {
      const options = {
        roomName:
          localStorage.getItem("roomToken") +
          "/" +
          localStorage.getItem("roomName"),

        parentNode: this.$refs.jitsiContainer,
        configOverwrite: {
          // toolbarButtons: ["select-background", "recording"],
          prejoinPageEnabled: false,
          disableSelfView: false,
          disableSelfViewSettings: true,
          hideDisplayName: true,
          // conferenceInfo: {
          //   alwaysVisible: ["raised-hands-count"],
          // },
          hideConferenceSubject: true,
          hideConferenceTimer: true,
          hideRecordingLabel: false,
          hideParticipantsStats: true,
          doNotFlipLocalVideo: true,
          disableLocalVideoFlip: true,
          disableReactions: false,
          requireDisplayName: false,
          enableWelcomePage: false,
          enableClosePage: true,
          enableDisplayNameInStats: false,
          disableTileView: true,
          disableTileEnlargement: true,
          disableSimulcast: true,
          startWithAudioMuted: true,
          // dropbox: {
          //   appKey: "46x7pnw1h1dbhzl",
          //   redirectURI:'http://127.0.0.1:8080/agent-console'
          // },
          fileRecordingsEnabled: false,
          fileRecordingsServiceEnabled: false,
          remoteVideoMenu: {
            disabled: true,
          },
          connectionIndicators: {
            disabled: true,
            disableDetails: true,
          },
          userInfo: {
            displayName: "agent",
            email: "kiosk@agent.com",
            id: "agent",
          },
          disabledSounds: ["RECORDING_ON_SOUND", "RECORDING_OFF_SOUND"],
        },
        interfaceConfigOverwrite: {
          VIDEO_QUALITY_LABEL_DISABLED: false,
        },
      };
      this.jitsiApi = new window.JitsiMeetExternalAPI(this.domain, options);
      this.jitsiApi.addListener("participantJoined", (event) => {
        const participantId = event.id;
        console.log(participantId, "participantId");
        // this.jitsiApi.executeCommand("grantModerator", participantId);
      });
      this.manageMic();
    },
    removeJitsiWidget() {
      if (this.jitsiApi) this.jitsiApi.dispose();
    },
    localMode() {
      // this?.jitsiApi?.executeCommand("toggleFilmStrip");
      // this?.jitsiApi?.executeCommand("toggleTileView");
      // this.manageMic("mode_change");
      if (this.video_mode_status == false) {
        this.video_mode_status = false;
        this.videoSetting.mode = "monitor";
        this.videoSetting.agent_mic = false;
        this.kioskCommunication.send(JSON.stringify(this.videoSetting));
      } else {
        this.video_mode_status = true;
        this.videoSetting.mode = "live";
        this.videoSetting.agent_mic = true;
        this.kioskCommunication.send(JSON.stringify(this.videoSetting));
      }
    },
    manageMic(data) {
      if (data !== undefined && data == "mode_change") {
        if (this.videoSetting.mode == "monitor" && this.micStatus) {
          this.micStatus = !this.micStatus;
          this.jitsiApi.executeCommand("toggleAudio");
        }
        if (this.videoSetting.mode == "live" && this.micStatus == false) {
          this.micStatus = !this.micStatus;
          this.jitsiApi.executeCommand("toggleAudio");
        }
      }
      this.micStatus = !this.micStatus;
      this.jitsiApi.executeCommand("toggleAudio");
      this.jitsiApi.addListener("audioMuteStatusChanged", (event) => {
        this.micStatus = !event.muted;
      });
    },
    endMeeting() {
      Swal.fire({
        title: "Are you sure?",
        text: "You won to end meeting!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#238dfa",
        cancelButtonColor: "#f46a6a",
        confirmButtonText: "Yes, I want!",
      }).then((result) => {
        if (result.value) {
          this.videoSetting.mode = "monitor";
          this.videoSetting.agent_mic = false;
          this.kioskCommunication.send(this.videoSetting);
          this.jitsiApi.executeCommand("hangup");
          window.location.reload();
          localStorage.clear();
        }
      });
    },
    watchSocketEvent() {
      this.kioskCommunication.onmessage = (event) => {
        const { command, message, sender } = JSON.parse(event.data);
        console.log(command, message, sender, "command, message, sender");
        const kioskId = localStorage.getItem("kiosk_id");
        if (sender.user_type == "kiosk_machine" && sender.id == kioskId) {
          if (message.mode == "live") {
            this.video_mode_status = true;
            this.videoSetting.mode = "live";
            this.videoSetting.agent_mic = true;
            this.isMinMax = true;
            this.jitsiApi.executeCommand("toggleFilmStrip");
            this.jitsiApi.executeCommand("toggleTileView");
          }
          if (message.mode == "monitor") {
            this.video_mode_status = false;
            this.videoSetting.mode = "monitor";
            this.videoSetting.agent_mic = false;
            this.isMinMax = false;
            this.jitsiApi.executeCommand("toggleFilmStrip");
            this.jitsiApi.executeCommand("toggleTileView");
          }
        }
      };
    },
    socketTrigger(param) {
      if (param == "wait") {
        this.checkin_step.current_step = "wait";
        this.checkin_step.wait = this.isOnWait;
      }
      if (param == "min_max") {
        this.checkin_step.current_step = "min_max";
        this.checkin_step.max_min = this.isMinMax;
      }
      if (param == "refresh_kiosk") {
        this.checkin_step.current_step = "refresh_kiosk";
        this.checkin_step.reset_kiosk = true;
      }
      console.log(this.kioskCommunication);
      this.kioskCommunication.send(JSON.stringify(this.checkin_step));
    },
    refreshKiosk() {
      this.socketTrigger("refresh_kiosk");
    },
    manageWait() {
      this.isOnWait = !this.isOnWait;
      this.socketTrigger("wait");
    },
    manageMinMax() {
      this.isMinMax = !this.isMinMax;
      this.socketTrigger("min_max");
    },
    resetConsoleValues() {
      this.isOnWait = false;
      this.isMinMax = false;
    },
  },
};
</script>

<template>
  <div>
    <div id="gridScreen" class="border shadow agent-video">
      <header class="rounded border-bottom border-primary rounded-0">
        <div class="mb-2">
          <div class="row align-items-center">
            <div class="col-md-3">
              <p class="text-light fs-5 mb-0 agent-name">{{ hotel.name }}</p>
            </div>
            <div class="col-md-6">
              <div class="d-flex align-items-center justify-content-center">
                <h4
                  class="text-light text-center text-uppercase mb-0 agent-text"
                >
                  Agent Console
                </h4>
              </div>
            </div>
            <div class="col-md-3">
              <div class="d-flex align-items-center justify-content-end">
                <p class="fs-5 mb-0 me-3 text-light agent-name">
                  {{
                    user.user.first_name !== null ? user.user.first_name : ""
                  }}
                  {{ user.user.last_name !== null ? user.user.last_name : "" }}
                  (Agent)
                </p>
                <button
                  class="btn p-2 px-3 fs-5 btn-danger min-100"
                  @click="endMeeting()"
                >
                  log out
                </button>
              </div>
            </div>
          </div>
        </div>
      </header>
      <div class="d-flex align-items-center justify-content-between my-2">
        <div class="">
          <div class="d-flex align-items-center justify-content-end">
            <button class="btn btn-outline-danger me-2" @click="refreshKiosk()">
              Refresh Kiosk
            </button>
            <div class="form-check form-switch form-switch-md">
              <label
                for="check-in"
                class="form-check-label text-light fs-5 text-capitalize"
              >
                Wait
              </label>
              <input
                class="form-check-input"
                type="checkbox"
                id="check-in"
                v-model="isOnWait"
                @click="manageWait()"
              />
            </div>
            <div class="form-check form-switch form-switch-md ms-2">
              <label
                for="min-max"
                class="form-check-label text-light fs-5 text-capitalize"
              >
                Min/Max
              </label>
              <input
                class="form-check-input"
                type="checkbox"
                id="min-max"
                v-model="isMinMax"
                @click="manageMinMax()"
              />
            </div>
          </div>
        </div>
      </div>
      <div id="videoContainer">
        <div class="row">
          <div class="col-xxl-12 col-xl-12 col-md-12">
            <div
              ref="jitsiContainer"
              id="meet"
              class="video-meet-agent"
              :class="
                videoSetting.mode == 'live' ? 'videoContainer-pointer' : ''
              "
            />
            <div
              class="d-flex align-items-center video-icon"
              @click="manageMic('mic_change')"
            >
              <i class="fas fa-microphone" v-if="micStatus" />
              <i class="fas fa-microphone-slash bg-red" v-else />
            </div>
            <div class="company-logo">
              <img src="../assets/images/logo.jpg" alt="" class="w-25" />
            </div>
          </div>
        </div>
      </div>
      <div class="switch-button mx-auto mt-3">
        <input
          class="switch-button-checkbox"
          v-model="video_mode_status"
          @change="localMode($event)"
          type="checkbox"
        />
        <label class="switch-button-label mb-0" for="">
          <span class="switch-button-label-span">Monitor</span>
        </label>
      </div>
    </div>
    <audio id="check_in_start" ref="check_in_start" class="d-none" controls>
      <source src="/assets/check_in.mp3" type="audio/mpeg" />
    </audio>
  </div>
</template>

<style scoped>
@keyframes animate {
  0%,
  40%,
  100% {
    transform: scale(0.8);
  }

  20% {
    transform: scale(0.4);
  }
}
.videoContainer-pointer {
  pointer-events: none;
}
.agent-video {
  padding: 20px;
  border-radius: 8px;
  background-color: #202124;
}
.video-meet-agent {
  height: calc(100vh - 208px);
}
.video-icon {
  position: absolute;
  bottom: 6px;
  left: 16px;
}
.video-icon i {
  padding: 10px;
  color: #fff;
  font-size: 16px;
  background-color: #2d2d2d;
  border-radius: 50%;
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.company-logo {
  position: absolute;
  top: 32px;
  left: 40px;
}
.bg-red {
  background-color: #cb2233 !important;
}
.border-bottom-dashed {
  border-bottom: 1px dotted #238dfa;
  margin: 10px 0px;
}
.status {
  height: 20px;
  width: 20px;
  border-radius: 12px;
}
.agent-text {
  text-shadow: black 3px 3px 3px;
}
.agent-name {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.min-100 {
  min-width: 100px;
}
</style>
